export const mapOptionObjectToArray = object => {
  const objectValue = object && Object.keys(object);

  return objectValue?.map(item => ({
    label: object?.[item],
    value: item,
  }));
};
export const optionsRole = [
  {
    label: "Log admin",
    value: 1,
  },
  {
    label: "Runner",
    value: 2,
  },
  {
    label: "Hub admin",
    value: 3,
  },
  {
    label: "Collector",
    value: 4,
  },
];
export const optionsFixedDayOff = [
  {
    label: "Thứ hai",
    value: "1",
  },
  {
    label: "Thứ ba",
    value: "2",
  },
  {
    label: "Thứ tư",
    value: "3",
  },
  {
    label: "Thứ năm",
    value: "4",
  },
  {
    label: "Thứ sáu",
    value: "5",
  },
  {
    label: "Thứ bảy",
    value: "6",
  },
  {
    label: "Chủ nhật",
    value: "0",
  },
];
export const mapArrayOptionToArrayValue = array => {
  if (array && array.length > 0) {
    return array.map(item => item.value);
  }

  return [];
};

export const mapArrayValueToArrayOption = (arrayValue, options) => {
  if (arrayValue && arrayValue.length > 0 && options && options.length > 0) {
    return arrayValue.map(value => options.find(item => item.value === value));
  }

  return [];
};

export const convertTimeToMinutes = timeString => {
  const [hours, minutes] = timeString.split(":");
  const hoursInMinutes = parseInt(hours, 10) * 60;
  const minutesInMinutes = parseInt(minutes, 10);
  const totalMinutes = hoursInMinutes + minutesInMinutes;

  return totalMinutes;
};

export const convertMinutesToTime = minutes => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(mins).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};
